import { LoadingOutlined } from "@ant-design/icons";
import { Button, Card, Col, Divider, Flex, Row, Space } from "antd";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";

import SubInfoSwitch from "components/elements/InfoSwitch/SubInfoSwitch";
import { Input, Select } from "components/form";

import schema, {
  initialValues as INITIAL_VALUES,
} from "../schemas/incomeSchema";
import styles from "../styles/Income.module.css";

const PayrollIncomeForm = ({
  blankForm = false,
  isLoading = false,
  initialValues = {},
  incomeDeductionByTypeOptions = [],
  roundingTypeOptions = [],
  fundOptions = [],
  frequencyOfPaymentOptions = [],
  taxCalculationOptions = [],
  onSubmit = () => { },
  onCancel = () => { },
}) => {
  const { t } = useTranslation();

  const overtimeCodeOptions = [
    {
      value: 'OT1',
      label: 'OT1',
    },
    {
      value: 'OT2',
      label: 'OT2',
    },
    {
      value: 'OT3',
      label: 'OT3',
    },
    {
      value: 'OT4',
      label: 'OT4',
    }
  ]

  return (
    <Formik
      enableReinitialize
      initialValues={blankForm ? INITIAL_VALUES : initialValues}
      onSubmit={onSubmit}
      validationSchema={schema}
    >
      {({ values = {}, setFieldValue }) => {
        return (
          <Form>
            <Card style={{ border: "1px solid #EAECF0" }}>
              <Row justify="space-between">
                <b className={styles.infoTopic}>
                  {t("income.label.income_detail")}
                </b>
              </Row>
              <Divider />
              {isLoading ? (
                <LoadingOutlined />
              ) : (
                <>
                  <Row gutter={[24, 16]}>
                    <Col span={12}>
                      <Input
                        name="code"
                        label={
                          t("income.label.code")
                        }
                        placeholder={
                          t("income.label.code")
                        }
                        size="large"
                        required
                      />
                    </Col>
                    <Col span={12}></Col>
                    <Col span={12}>
                      <Input
                        name="name"
                        label={
                          t("income.label.name_th")
                        }
                        placeholder={
                          t("income.label.name_th")
                        }
                        size="large"
                        required
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        name="nameEn"
                        label={
                          t("income.label.name_en")
                        }
                        placeholder={
                          t("income.label.name_en")
                        }
                        size="large"
                        required
                      />
                    </Col>
                    <Col span={12}>
                      <Select
                        name="incomeType"
                        label={
                          t("income.label.type")
                        }
                        placeholder={t("please-select-0")}
                        size="large"
                        options={incomeDeductionByTypeOptions}
                        required
                      />
                    </Col>
                    <Col span={12}>
                      <Select
                        name="rounding"
                        label={
                          t("income.label.rounding")
                        }
                        placeholder={t("please-select-0")}
                        size="large"
                        options={roundingTypeOptions}
                        required
                      />
                    </Col>
                  </Row>
                  <Col span={24}>
                    <div style={{ paddingTop: "24px" }}>
                      <Row justify="space-between">
                        <b className={styles.infoTopic}>
                          {t("income.label.payment_condition")}
                        </b>
                      </Row>
                      <Divider />
                      <Row gutter={[24, 16]}>
                        <Col span={12}>
                          <Select
                            name="frequencyOfPayment"
                            label={
                              t("income.label.frequency_of_payment")
                            }
                            placeholder={t("please-select-0")}
                            size="large"
                            options={frequencyOfPaymentOptions}
                            required
                          />
                        </Col>
                        <Col span={6}>
                          <SubInfoSwitch
                            label={t("income.label.off_period")}
                            value={values.offPeriod}
                            onChange={(val) =>
                              setFieldValue("offPeriod", val)
                            }
                          />
                        </Col>
                        <Col span={6}>
                          <SubInfoSwitch
                            label={t("income.label.previous_period")}
                            value={values.previousPeriod}
                            onChange={(val) =>
                              setFieldValue("previousPeriod", val)
                            }
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div style={{ paddingTop: "24px" }}>
                      <Row justify="space-between">
                        <b className={styles.infoTopic}>
                          {t("income.label.other_condition")}
                        </b>
                      </Row>
                      <Divider />
                      <Row gutter={[24, 16]}>
                        <Col span={12}>
                          <Select
                            name="taxCalculation"
                            label={t("income.label.tax_calculation")}
                            placeholder={t("please-select-0")}
                            size="large"
                            options={taxCalculationOptions}
                          />
                        </Col>
                        <Col span={12} />
                        <Col span={24}>
                          <b className={styles.infoSubTopic}>
                            {t("income.label.calculate_income_with")}
                          </b>
                        </Col>
                        <Col span={6}>
                          <SubInfoSwitch
                            label={t("income.label.social_security_fund")}
                            value={values.socialSecurityFund}
                            onChange={(val) =>
                              setFieldValue("socialSecurityFund", val)
                            }
                          />
                        </Col>
                        <Col span={6}>
                          <SubInfoSwitch
                            label={t("income.label.provident_fund")}
                            value={values.providentFund}
                            onChange={(val) =>
                              setFieldValue("providentFund", val)
                            }
                          />
                        </Col>
                        <Col span={6}>
                          <SubInfoSwitch
                            label={t("deduction.label.fund")}
                            value={values.fund}
                            onChange={(val) =>
                              setFieldValue("fund", val)
                            }
                          />
                        </Col>
                        <Col span={6}></Col>
                        <Col span={6}>
                          <Flex vertical gap={16}>
                            <SubInfoSwitch
                              label={t("income.label.overtime")}
                              value={values.overTime}
                              onChange={(val) => setFieldValue("overTime", val)}
                            />
                            {values?.overTime === true &&
                              <Select
                                name="overtimeCode"
                                label={t("income.label.overtime_code")}
                                required
                                placeholder={t("please-select-0")}
                                size="large"
                                options={overtimeCodeOptions}
                              />
                            }

                          </Flex>
                        </Col>
                        <Col span={6}>
                          <SubInfoSwitch
                            label={t("income.label.late_or_absent_deduction")}
                            value={values.lateOrAbsentDeduction}
                            onChange={(val) =>
                              setFieldValue("lateOrAbsentDeduction", val)
                            }
                          />
                        </Col>
                        {!values.fund ? "" :
                          <Col span={6}>
                            <Select
                              name="fundList"
                              mode={"multiple"}
                              // label={
                              //   t("deduction.label.type")
                              // }
                              placeholder={
                                t("please-select-0")
                              }
                              size="large"
                              options={fundOptions}
                              required
                            />
                          </Col>
                        }
                      </Row>
                    </div>
                  </Col>
                  <Row justify="end" style={{ paddingTop: "24px" }}>
                    <Space size={12}>
                      <Button type="default" onClick={onCancel} style={{ height: "40px", borderRadius: "8px" }}>
                        {t("common.cancel").toUpperCase()}
                      </Button>
                      <Button type="primary" htmlType="submit" style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}>
                        {t("common.submit").toUpperCase()}
                      </Button>
                    </Space>
                  </Row>
                </>
              )}
            </Card>
          </Form>
        );
      }}
    </Formik>
  );
};

export default PayrollIncomeForm;
